import { ReducerUser, ReduxActionData } from '../../types/reducers'
import { USER_ACTIONS } from '../actions/user'

const initialState: ReducerUser = {
    userInfo: null,
    authToken: ''
}

const userState: (state: ReducerUser, action: ReduxActionData<any, USER_ACTIONS>) => ReducerUser = (
    // eslint-disable-next-line default-param-last
    state = initialState,
    action: ReduxActionData<any, USER_ACTIONS>
) => {
    switch (action.type) {
        case USER_ACTIONS.SET_USER_DATA:
            return {
                ...state,
                userInfo: action.payload,
            }
        case USER_ACTIONS.SET_USER_AUTH_TOKEN:
            return {
                ...state,
                authToken: action.payload,
            }
        case USER_ACTIONS.LOGOUT_USER:
            return initialState
        default:
            return state
    }
}

export default userState
